import {
    getInternetConnectionSpeedKbps,
    getIsInternetConnectionModuleInited,
} from '../../../modules/InternetConnection/internetConnectionSelectors';
import { useDispatch, useSelector } from 'react-redux';
import LogoScreen from '../../../components/Logo/LogoScreen';
import MobileAppOnboardingStaticLoadable from './MobileAppOnboardingStatic/MobileAppOnboardingStaticLoadable';
import MobileAppOnboardingAnimatedLoadable from './MobileAppOnboardingAnimated/MobileAppOnboardingAnimatedLoadable';
import { useEffect } from 'react';
import { logAction } from '../../../app/appActions';

function MobileAppOnboarding() {
    const isInternetConnectionModuleInited = useSelector(getIsInternetConnectionModuleInited);
    const internetConnectionSpeedKbps = useSelector(getInternetConnectionSpeedKbps);
    const dispatch = useDispatch();
    const isFlowStatic = false;

    useEffect(() => {
        if (isInternetConnectionModuleInited) {
            dispatch(logAction({
                flow: isFlowStatic ? 'static' : 'animated',
                page: 'mobile-onboarding',
                speedKbps: internetConnectionSpeedKbps,
            }));
        }
    }, [dispatch, internetConnectionSpeedKbps, isFlowStatic, isInternetConnectionModuleInited]);

    if (!isInternetConnectionModuleInited) {
        return <LogoScreen/>;
    }

    return isFlowStatic
        ? <MobileAppOnboardingStaticLoadable/>
        : <MobileAppOnboardingAnimatedLoadable/>;
}

export default MobileAppOnboarding;
